<template>
    <view>
      <div class="index_links_box margin-15">
        <div class="container">
            <div class="index_links">
                <p v-for="(item,index) in links" :key="index">
                    <b>{{item.name}}：</b>
                    <a v-for="(items,index) in item.data" :key="index" :href="items.url" target="_blank">{{items.name}}</a>
                </p>
              </div>
            </div>
        </div>
        <div class="footer">
          <div class="container">
            <div>联系电话：0870-7122819&nbsp;&nbsp;&nbsp;&nbsp;投稿邮箱：qjxzfxwzx@126.com</div>
            <div>互联网新闻信息服务许可证编号：53120210080&nbsp;&nbsp;信息网络传播视听节目许可证号：125420109 &nbsp;&nbsp;滇ICP备2021007275号</div>
            <div>中共巧家县委宣传部主办&nbsp;&nbsp;巧家县融媒体中心承办&nbsp;&nbsp;巧家新闻网版权所有&nbsp;&nbsp;未经许可不得复制、转载</div>
          </div>
          <footer class="copyright">
            <div class="wow fadeInLeft">Copyright © 2017-2025&nbsp;<a href="https://www.ynqjnews.net">YNQJNEWS.NET</a>&nbsp;All rights reserved. &nbsp;&nbsp;技术支持：昭通报业有限责任公司.</div>
            <div class="ga_beian wow fadeInRight">
              <a class="ga_link" href="https://beian.mps.gov.cn/#/query/webSearch?code=53062202000127" rel="noreferrer" target="_blank">
                <img src="../assets/images/gabeian.png" style="float:left;">
                <p class="ga_no">滇公网安备53062202000127</p>
              </a>
            </div>
          </footer>
        </div>
        <div class="col-sm-12 col-md-12 col-xs-12" style="text-align: center; margin:0px auto; padding: 0px 15px 5px 15px; background:#ffffff">
          <a href="https://www.12377.cn/" target="_blank" style="padding-right:10px;"><img src="../assets/images/bljb.jpg" style="margin-top:10px;height: 50px;"></a>
          <a href="https://www.yn12377.cn/jubao/" target="_blank" style="padding-right:10px;"><img src="../assets/images/wfjb.png" style="margin-top:10px;height: 50px;"></a>
          <a href="https://www.yn12377.cn/jubao/jubao/smjb?type=09&amp;stype=0906" target="_blank" style="padding-right:10px;"><img src="../assets/images/sqjb.png" style="margin-top:10px;height: 50px;"></a>
          <a href="https://bszs.conac.cn/sitename?method=show&amp;id=119A2D68A1DF05CFE053012819AC8CA0" target="_blank" style="padding-right:10px;"><img src="../assets/images/dzjg.png" style="margin-top:10px;height: 50px;"></a>
        </div>
      </view>
    </template>
      
    <script>
      import { post } from '../request' 
      export default {
        name: 'FooterPage',
        data(){
          return{
            links: [
              { id: 11, name: '中央新闻网站', data: []},  
              { id: 19, name: '省级新闻网站', data: []},  
              { id: 20, name: '市级网站', data: []},  
              { id: 21, name: '政务类网站', data: []},  
            ],  

          }
        },
        created() {
          this.getLinks()
        },
        methods: {
          async getLinks() {  
                try {  
                    for (const onlinks of this.links) { 
                        const postData = {'page': 1,'length': 4};
                        const response = await post(`/page/links/${onlinks.id}`, postData);  
                        if (response.data) {  
                            onlinks.data = response.data;
                        }  
                    }  
                } catch (error) {  
                    console.error('Error fetching institution data:', error);  
                }  
            },    
        },
    
      }
    </script>
    
      